import { AIContextSchemaPayload } from './state'

export enum ActionType {
  ADD_AI_CONTEXT,
  REMOVE_AI_CONTEXT,
  SET_AI_FEATURE_ID_IN_EDIT,
  SET_CONTEXT_SCHEMA,
  RESET_AI_RESULT_CONTEXT,
}

export interface AddAIContext {
  type: ActionType.ADD_AI_CONTEXT
  payload: any
}

export interface RemoveAIContext {
  type: ActionType.REMOVE_AI_CONTEXT
  payload: {
    id: string
  }
}

export interface SetAIFeatureIdInEdit {
  type: ActionType.SET_AI_FEATURE_ID_IN_EDIT
  payload: string | null
}

export interface SetAIContextSchema {
  type: ActionType.SET_CONTEXT_SCHEMA
  payload: AIContextSchemaPayload
}

export interface ResetAIResultContext {
  type: ActionType.RESET_AI_RESULT_CONTEXT
}

export type AIContextActions = AddAIContext | RemoveAIContext | SetAIFeatureIdInEdit | SetAIContextSchema | ResetAIResultContext
